module.exports = __webpack_public_path__ + "static/media/priceImageBg.a6df0f51.svg";